import { useEnterStore } from 'hooks/stores/useEnterStore';
import { useRootStore } from 'hooks/stores/useRootStore';
import { useUIStore } from 'hooks/stores/useUIStore';
import { useUserStore } from 'hooks/stores/useUserStore';
import { useEffect } from 'react';
import { getCheckout2026Value } from 'utils/ab-test/abTests';

/** Checks that the current state of the various stores is valid for the user to
 * use the enter flow. e.g. if they already have an active subscription then
 * they are booted out of the flow
 */
export function useEnterFlowPreconditionCheck() {
  const rootStore = useRootStore();
  const userStore = useUserStore();
  const enterStore = useEnterStore();
  const uiStore = useUIStore();

  useEffect(() => {
    if (userStore.userInitialized && enterStore.initialised) {
      if (
        userStore.activeSubscriptions.length > 0 &&
        !enterStore.isUpgradeFlow
      ) {
        uiStore.navigateToDashboard();
        uiStore.displayToast({
          title:
            'You already have an active subscription to the Weekly Draw. Multiple subscriptions to the Weekly Draw are not allowed.',
          color: '#FF6600',
          timeout: 3500,
        });
      }
    }
  }, [
    // Importantly, we only want to run this once when the user store has initialised. Otherwise, we may end up running
    // the effect when the number of activeSubscriptions changes
    userStore.userInitialized,
    enterStore.initialised,
  ]);

  useEffect(() => {
    const checkoutVariant = getCheckout2026Value();
    if (
      (checkoutVariant === 'V1' || checkoutVariant === 'V2') &&
      rootStore.initialized &&
      !enterStore.boosted
    ) {
      enterStore.setBoosted(true);
    }
  }, [rootStore.initialized]);
}
